module.exports = __webpack_public_path__ + "media/auto_history/zmiana_rejestracji-0eff1912.png";